import { memo } from 'react';
import Typography from '@mui/material/Typography';
import theme from '@wavetrak/theme';
import LiveCamButton from 'components/LiveCamButton';
import { SpotDetails } from 'types/spot';
import styles from './LiveCamPaywall.module.scss';

const LiveCamPaywall = ({
  backgroundImage,
  spot,
}: {
  backgroundImage: string;
  spot: SpotDetails;
}) => (
  <div className={styles.liveCamPaywall}>
    <div
      className={styles.backgroundImage}
      style={{ backgroundImage: `url(${backgroundImage})` }}
      data-testid="live-cam-paywall"
    />
    <Typography
      variant="headline"
      component="p"
      color={theme.palette.text.base}
      className={styles.ctaText}
    >
      Watch the live cam with Premium
    </Typography>
    <LiveCamButton dataTestId="go-live-button" spot={spot} />
  </div>
);

export default memo(LiveCamPaywall);
